import { Injectable } from '@angular/core';
import { HttpHeadersService } from './http-headers.service';
import { HttpClient } from '@angular/common/http';
import { RoleRequestDTO } from '../models/RoleRequestDTO';
import { RoleResponseDTO } from '../models/RoleResponseDTO';
import { MenuListRequestDTO } from '../models/MenuListRequestDTO';
import { MenuListResponseDTO } from '../models/MenuListResponseDTO';
import { CreateRoleRequestDTO } from '../models/CreateRoleRequestDTO';
import { CreateRoleResponseDTO } from '../models/CreateRoleResponseDTO';
import { Urls } from '../utilities/urls.component';
import { DeleteRoleResponseDTO } from '../models/DeleteRoleResponseDTO';
import { RoleHoldersRequestDTO } from '../models/RoleHoldersRequestDTO';
import { RoleHoldersResponseDTO } from '../models/RoleHoldersResponseDTO';
import { Utils } from '../utilities/util.component';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class RolesService {
  getOrglistApi = new Subject();

  getOrgListForSubscription(): Observable<any> {
    let data = new Observable<any>((observer) => {
      setTimeout(() => {
        observer.next(this.getOrglistApi);
      }, 2000);
    });
    return data;
  }

  // API_ENDPOINT: string;
  constructor(private http: HttpClient, private headers: HttpHeadersService) {
    // this.API_ENDPOINT = localStorage.getItem("ENDPOINT");
  }

  getRoleList(orgId: string) {
    if (Utils.isAdmin() && localStorage.getItem('WhichTeamTab') == 'Organisation') {
      var url: string = Urls.API_ENDPOINT + Urls.ROLES.getOrgRoleList + orgId;
      return this.http.get<RoleResponseDTO>(url, this.headers.getCommonHttpHeaders());
    } else if (Utils.isAdmin()) {
      var url: string = Urls.API_ENDPOINT + Urls.ROLES.getAdminRoleList;
      return this.http.get<RoleResponseDTO>(url, this.headers.getCommonHttpHeaders());
    } else {
      var url: string = Urls.API_ENDPOINT + Urls.ROLES.getOrgRoleList + orgId;
      return this.http.get<RoleResponseDTO>(url, this.headers.getCommonHttpHeaders());
    }
  }

  getAdminRoleList() {
    if (Utils.isAdmin()) {
      var url: string = Urls.API_ENDPOINT + Urls.ROLES.getAdminRoleList;
      return this.http.get<RoleResponseDTO>(url, this.headers.getCommonHttpHeaders());
    }
    return null;
  }

  getMenuList() {
    let id = 2;
    if (Utils.isAdmin() && localStorage.getItem('WhichTeamTab') == 'Organisation') {
      id = 2; //partnerAdmin
      if (localStorage.getItem('selectedOrgType')?.toLowerCase() === 'regulator') {
        id = 3;
      }
    } else if (Utils.isAdmin()) {
      id = 1;
    }

    var url: string = Urls.API_ENDPOINT + Urls.ROLES.getMenuList + '/' + id;
    return this.http.get<MenuListResponseDTO>(url, this.headers.getCommonHttpHeaders());
  }

  createRole(request) {
    if (Utils.isAdmin() && localStorage.getItem('WhichTeamTab') == 'Organisation') {
      var url: string = Urls.API_ENDPOINT + Urls.ROLES.createOrgRole;
      return this.http.post<CreateRoleResponseDTO>(url, request, this.headers.getCommonHttpHeaders());
    } else if (Utils.isAdmin()) {
      var url: string = Urls.API_ENDPOINT + Urls.ROLES.createAdminRole;
      return this.http.post<CreateRoleResponseDTO>(url, request, this.headers.getCommonHttpHeaders());
    }
    var url: string = Urls.API_ENDPOINT + Urls.ROLES.createOrgRole;
    return this.http.post<CreateRoleResponseDTO>(url, request, this.headers.getCommonHttpHeaders());
  }

  updateRole(request) {
    if (Utils.isAdmin() && localStorage.getItem('WhichTeamTab') == 'Organisation') {
      var url: string = Urls.API_ENDPOINT + Urls.ROLES.updateOrgRole;
      return this.http.post<CreateRoleResponseDTO>(url, request, this.headers.getCommonHttpHeaders());
    } else if (Utils.isAdmin()) {
      var url: string = Urls.API_ENDPOINT + Urls.ROLES.updateAdminRole;
      return this.http.post<CreateRoleResponseDTO>(url, request, this.headers.getCommonHttpHeaders());
    }
    var url: string = Urls.API_ENDPOINT + Urls.ROLES.updateOrgRole;
    return this.http.post<CreateRoleResponseDTO>(url, request, this.headers.getCommonHttpHeaders());
  }

  deleteRole(roleId: number) {
    if (Utils.isAdmin() && localStorage.getItem('WhichTeamTab') == 'Organisation') {
      var url: string = Urls.API_ENDPOINT + Urls.ROLES.deleteOrgRole + roleId;
      return this.http.get<DeleteRoleResponseDTO>(url, this.headers.getCommonHttpHeaders());
    } else if (Utils.isAdmin()) {
      var url: string = Urls.API_ENDPOINT + Urls.ROLES.deleteAdminRole + roleId;
      return this.http.get<DeleteRoleResponseDTO>(url, this.headers.getCommonHttpHeaders());
    }
    var url: string = Urls.API_ENDPOINT + Urls.ROLES.deleteOrgRole + roleId;
    return this.http.get<DeleteRoleResponseDTO>(url, this.headers.getCommonHttpHeaders());
  }

  roleHoldersNameAndCount(request: RoleHoldersRequestDTO) {
    var url: string = Urls.API_ENDPOINT + Urls.ROLES.getroleHolders;
    return this.http.post<RoleHoldersResponseDTO>(url, request, this.headers.getCommonHttpHeaders());
  }
  getUserRoleByEmailId(request: any) {
    var url: string = Urls.API_ENDPOINT + Urls.ROLES.getUserRoleByEmailId;
    return this.http.post<RoleResponseDTO>(url, request, this.headers.getCommonHttpHeaders());
  }
}
